import { NavLink } from 'react-router-dom';
import { motion } from 'framer-motion';
import {
  HomeIcon,
  ChartBarIcon,
  DocumentTextIcon,
  CubeIcon,
  DocumentPlusIcon,
} from '@heroicons/react/24/outline';
import { useAuth } from '../AuthContext';

const OFFICE = [
  { to: '/staff/app', icon: HomeIcon, label: 'Home', end: true },
  { to: '/staff/app/office/dashboard', icon: ChartBarIcon, label: 'Dashboard' },
  { to: '/staff/app/office/reports', icon: DocumentTextIcon, label: 'Reports' },
  { to: '/staff/app/office/inventory', icon: CubeIcon, label: 'Inventory' },
];
const TECH = [
  { to: '/staff/app', icon: HomeIcon, label: 'Home', end: true },
  { to: '/staff/app/report/new', icon: DocumentPlusIcon, label: 'New' },
  { to: '/staff/app/reports', icon: DocumentTextIcon, label: 'Reports' },
];

export default function BottomTabs() {
  const { isOffice } = useAuth();
  const items = isOffice ? OFFICE : TECH;

  return (
    <nav className="lg:hidden fixed bottom-0 inset-x-0 z-30 flex bg-navy/95 backdrop-blur border-t border-white/10">
      {items.map(({ to, icon: Icon, label, end }) => (
        <NavLink key={to} to={to} end={!!end} className="relative flex-1 flex flex-col items-center gap-0.5 py-2.5">
          {({ isActive }) => (
            <>
              {isActive && (
                <motion.span layoutId="staff-tab-ind"
                  className="absolute top-0 h-0.5 w-8 rounded-full bg-lime"
                  transition={{ type: 'spring', stiffness: 400, damping: 32 }} />
              )}
              <Icon className={`h-5 w-5 ${isActive ? 'text-lime' : 'text-white/55'}`} />
              <span className={`text-[11px] ${isActive ? 'text-lime font-semibold' : 'text-white/55'}`}>{label}</span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
}
